import {merge} from "lodash";
import partnerMessages from "@i18n_messages_zh-CN"

export default merge({}, partnerMessages);